import { render } from "./PrivacyPolicyModal.vue?vue&type=template&id=a175b9ec&scoped=true"
import script from "./PrivacyPolicyModal.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyModal.vue?vue&type=script&lang=js"

import "./PrivacyPolicyModal.vue?vue&type=style&index=0&id=a175b9ec&lang=css"
import "./PrivacyPolicyModal.vue?vue&type=style&index=1&id=a175b9ec&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a175b9ec"]])

export default __exports__